module.exports = __webpack_public_path__ + "media/images/preview-edfa0ef36703433629933ae5238acb2d.svg";